import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import Parse from "parse";
import { markSessionInvalid } from "./utils/sessionGuard";
import { initInstallTracking } from "./utils/installEligibility";

// Inside the desktop device-frame iframe (loaded with ?_phoneview=1), tag the
// document so global CSS can swap cursors / disable hover affordances and read
// as a phone experience even when controlled by a mouse.
if (new URLSearchParams(window.location.search).has("_phoneview")) {
  document.documentElement.classList.add("desktop-preview");
}

Parse.initialize("scrawl");
// eslint-disable-next-line
Parse.serverURL = process.env.VUE_APP_API;

// The auth module's state factory runs during ES module evaluation (before this
// line), so Parse.User.current() there returns null. Sync the real current user
// into the store now that Parse is initialized.
store.commit("auth/SET_USER", Parse.User.current());

// Capture `beforeinstallprompt` at the earliest possible moment. The event
// fires shortly after page load and only once; if InstallBanner.vue (lazy-
// loaded from Home.vue) hasn't mounted yet we'd lose it. The eligibility
// module caches it for the component to consume on mount.
initInstallTracking();

const app = createApp(App);

function isInvalidSessionError(err) {
  return err && err.code === Parse.Error.INVALID_SESSION_TOKEN;
}

app.config.errorHandler = (err) => {
  if (isInvalidSessionError(err)) markSessionInvalid();
};

// Unhandled rejections (e.g. async lifecycle calls that aren't awaited at the
// call site) bypass app.config.errorHandler. Catch them here so a 209 from any
// fire-and-forget Parse query still flips the session-invalid flag.
window.addEventListener("unhandledrejection", (event) => {
  if (isInvalidSessionError(event.reason)) {
    markSessionInvalid();
    event.preventDefault();
  }
});

app.use(store).use(router).mount("#app");
